import { Component } from '@angular/core';
import { MethodBase } from '../base/base.component';
import { AuthMethodViewModel, YubikeyAuthMethodViewModel } from '../../../../services/identity';
import { FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-method-yubikey',
  standalone: false,
  templateUrl: './yubikey.component.html',
  styleUrl: './yubikey.component.scss'
})
export class YubikeyComponent extends MethodBase {

  private yubikeyMethod: YubikeyAuthMethodViewModel;
  private showSerialNumber: boolean;

  constructor(
    private fb: FormBuilder
  ) {
    super();
  }

  override ngOnInit() {
    super.ngOnInit();
    this.setup();
    this.monitorFormStatus();

  }

    setup(): void {
      this.yubikeyMethod = this.method as YubikeyAuthMethodViewModel;
      this.form = this.fb.group({
        code: [this.yubikeyMethod.code, [Validators.required, Validators.minLength(12)]]
      });
    }
    cancel(): void {
        
    }
    getMethod(): YubikeyAuthMethodViewModel {
      this.yubikeyMethod.code = this.form.value.code;
      return this.yubikeyMethod;
    }

}
